import * as React from "react";
import styled from "styled-components";
import * as sanitizeHtml from "sanitize-html";
import { graphql, useStaticQuery } from "gatsby";
import theme from "../ui/theme";

const NieuwsContainer = styled.div`
  width: 100vw;
  height: auto;
  padding-top: 100px;
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1250px) {
    height: auto;
  }
`;
const NieuwsFrame = styled.div`
  width: 60vw;
  a {
    line-height: 3rem;
    color: white;
    background-color: ${theme.common.blue};
    padding: 7px 10px 7px 10px;
    margin: 20px;
    border-radius: 2px;
    text-decoration: none;
  }
  @media only screen and (max-width: 1250px) {
    width: 80vw;
  }
`;
const DateAndAuthorBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  p {
    font-weight: 500;
    font-size: 0.8rem;
    color: ${theme.common.blue};
  }
`;
const Tussen = styled.p`
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 300;
  color: ${theme.common.black} !important;
  font-family: "OpenSans", sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
`;
const Date = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  p {
    color: ${theme.common.bordergrey};
  }
`;

const Nieuws = ({ data }) => {
  const queryNieuwsartikel = useStaticQuery(graphql`
    query getAllNieuwsArtikel {
      allStrapiNieuwsartikel {
        nodes {
          updatedBy {
            data {
              attributes {
                firstname
                lastname
              }
            }
          }
          updatedAt(formatString: "DD/MM/YYYY")
          Titel
          Veld {
            data {
              Veld
            }
          }
        }
      }
    }
  `);
  const nieuwsArtikel = queryNieuwsartikel.allStrapiNieuwsartikel.nodes[0];
  const author = nieuwsArtikel.updatedBy.data.attributes;
  const date = nieuwsArtikel.updatedAt;
  const createMarkup = () => {
    var clean = sanitizeHtml(nieuwsArtikel.Veld.data.Veld);
    return { __html: clean };
  };
  return (
    <>
      <NieuwsContainer>
        <NieuwsFrame>
          <h2>{data}</h2>
          <h3>{nieuwsArtikel.Titel}</h3>
          <DateAndAuthorBox>
            <Tussen>Door</Tussen>
            <p>{author.firstname + " " + author.lastname}</p>
            <Date>
              <p>@</p>
              <p>{date}</p>
            </Date>
          </DateAndAuthorBox>
          <div
            dangerouslySetInnerHTML={createMarkup()}
            className="ckContent"
          ></div>
        </NieuwsFrame>
      </NieuwsContainer>
    </>
  );
};

export default Nieuws;
